import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { DollarSignIcon, CalendarIcon, BuildingIcon, FileTextIcon, UploadIcon, InfoIcon, AlertCircleIcon, XIcon, CheckCircleIcon } from 'lucide-react';
import Card from '../../components/Card';
import Button from '../../components/Button';
const SukukInitiation = () => {
  const navigate = useNavigate();
  const [purpose, setPurpose] = useState('equipment');
  const [amount, setAmount] = useState(25000);
  const [duration, setDuration] = useState(6);
  const [selectedVendor, setSelectedVendor] = useState('');
  const [showVendorModal, setShowVendorModal] = useState(false);
  const [newVendorSubmitted, setNewVendorSubmitted] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  // Handle vendor selection change
  const handleVendorChange = e => {
    const value = e.target.value;
    setSelectedVendor(value);
    if (value === 'new_vendor') {
      setShowVendorModal(true);
    }
  };
  // Handle new vendor submission
  const handleVendorSubmit = e => {
    e.preventDefault();
    setShowVendorModal(false);
    setNewVendorSubmitted(true);
    setSelectedVendor('');
  };
  // Handle submission of the application
  const handleSubmit = e => {
    e.preventDefault();
    setShowConfirmation(true);
  };
  // Handle confirmation modal close and redirect
  const handleConfirmationClose = () => {
    navigate('/msme-dashboard');
  };
  if (showConfirmation) {
    return <div className="min-h-screen bg-neutral-50 flex flex-col justify-center items-center p-4" data-id="element-1279">
        <div className="w-full max-w-md" data-id="element-1280">
          <Card data-id="element-1281">
            <div className="text-center mb-6" data-id="element-1282">
              <div className="flex justify-center mb-4" data-id="element-1283">
                <div className="w-16 h-16 rounded-full bg-success bg-opacity-10 flex items-center justify-center" data-id="element-1284">
                  <CheckCircleIcon className="w-8 h-8 text-success" data-id="element-1285" />
                </div>
              </div>
              <h2 className="text-xl font-bold text-success" data-id="element-1286">
                Application Submitted Successfully!
              </h2>
              <p className="text-neutral-500 mt-2" data-id="element-1287">
                Your micro-sukuk application has been submitted for review.
              </p>
            </div>
            <div className="bg-neutral-50 p-4 rounded-lg mb-6" data-id="element-1288">
              <h3 className="font-medium mb-2" data-id="element-1289">Next Steps</h3>
              <ol className="space-y-3 text-sm" data-id="element-1290">
                <li className="flex items-start" data-id="element-1291">
                  <div className="w-6 h-6 rounded-full bg-primary flex items-center justify-center mr-2 flex-shrink-0 mt-0.5" data-id="element-1292">
                    <span className="text-white text-xs" data-id="element-1293">1</span>
                  </div>
                  <div data-id="element-1294">
                    <span className="font-medium" data-id="element-1295">Digital Advisor Review</span>
                    <p className="text-neutral-500" data-id="element-1296">
                      A Digital Advisor will review your application for
                      completeness.
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-1297">
                  <div className="w-6 h-6 rounded-full bg-neutral-200 flex items-center justify-center mr-2 flex-shrink-0 mt-0.5" data-id="element-1298">
                    <span className="text-neutral-600 text-xs" data-id="element-1299">2</span>
                  </div>
                  <div data-id="element-1300">
                    <span className="font-medium" data-id="element-1301">Rating Assessment</span>
                    <p className="text-neutral-500" data-id="element-1302">
                      Your application will be assessed for risk rating.
                    </p>
                  </div>
                </li>
                <li className="flex items-start" data-id="element-1303">
                  <div className="w-6 h-6 rounded-full bg-neutral-200 flex items-center justify-center mr-2 flex-shrink-0 mt-0.5" data-id="element-1304">
                    <span className="text-neutral-600 text-xs" data-id="element-1305">3</span>
                  </div>
                  <div data-id="element-1306">
                    <span className="font-medium" data-id="element-1307">
                      Shariah Compliance Review
                    </span>
                    <p className="text-neutral-500" data-id="element-1308">
                      Shariah advisors will verify compliance.
                    </p>
                  </div>
                </li>
              </ol>
            </div>
            <div className="bg-primary bg-opacity-5 border border-primary border-opacity-20 rounded-lg p-4 mb-6" data-id="element-1309">
              <div className="flex items-center" data-id="element-1310">
                <InfoIcon className="w-5 h-5 text-primary mr-2 flex-shrink-0" data-id="element-1311" />
                <p className="text-sm" data-id="element-1312">
                  You'll receive notifications as your application progresses
                  through each stage. The review process typically takes 7-14
                  business days.
                </p>
              </div>
            </div>
            <div className="flex justify-center" data-id="element-1313">
              <Button variant="primary" onClick={handleConfirmationClose} data-id="element-1314">
                Return to Dashboard
              </Button>
            </div>
          </Card>
        </div>
      </div>;
  }
  return <div className="max-w-4xl mx-auto" data-id="element-1315">
      <div className="mb-6" data-id="element-1316">
        <h1 className="text-2xl font-bold text-secondary mb-2" data-id="element-1317">
          Micro-Sukuk Initiation
        </h1>
        <p className="text-neutral-400" data-id="element-1318">
          Configure your Shariah-compliant financing for business growth
        </p>
        <div className="mt-3 bg-primary bg-opacity-5 border border-primary border-opacity-20 rounded-lg p-3" data-id="element-1319">
          <div className="flex items-center" data-id="element-1320">
            <InfoIcon className="w-5 h-5 text-primary mr-2 flex-shrink-0" data-id="element-1321" />
            <p className="text-sm" data-id="element-1322">
              <span className="font-medium" data-id="element-1323">MSME Submission:</span> After
              submitting this application, the Digital Advisor will review your
              information, followed by rating assessment, Shariah compliance
              review, and contract signing before listing on the marketplace.
            </p>
          </div>
        </div>
      </div>
      <form onSubmit={handleSubmit} data-id="element-1324">
        {/* Purpose Selection */}
        <section className="mb-8" data-id="element-1325">
          <Card data-id="element-1326">
            <h3 className="text-lg font-medium mb-4" data-id="element-1327">
              1. Select Financing Purpose
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4" data-id="element-1328">
              <div className={`border rounded-lg p-4 cursor-pointer transition-colors ${purpose === 'equipment' ? 'border-primary bg-primary bg-opacity-5' : 'border-neutral-200 hover:border-primary'}`} onClick={() => setPurpose('equipment')} data-id="element-1329">
                <div className="w-10 h-10 rounded-full bg-primary bg-opacity-10 flex items-center justify-center mb-3" data-id="element-1330">
                  <BuildingIcon className="w-5 h-5 text-primary" data-id="element-1331" />
                </div>
                <h4 className="font-medium mb-1" data-id="element-1332">Equipment Purchase</h4>
                <p className="text-sm text-neutral-400" data-id="element-1333">
                  Finance new machines, tools, or technology
                </p>
              </div>
              <div className={`border rounded-lg p-4 cursor-pointer transition-colors ${purpose === 'inventory' ? 'border-primary bg-primary bg-opacity-5' : 'border-neutral-200 hover:border-primary'}`} onClick={() => setPurpose('inventory')} data-id="element-1334">
                <div className="w-10 h-10 rounded-full bg-neutral-200 flex items-center justify-center mb-3" data-id="element-1335">
                  <DollarSignIcon className="w-5 h-5 text-neutral-500" data-id="element-1336" />
                </div>
                <h4 className="font-medium mb-1" data-id="element-1337">Inventory Financing</h4>
                <p className="text-sm text-neutral-400" data-id="element-1338">
                  Purchase stock and supplies
                </p>
              </div>
              <div className={`border rounded-lg p-4 cursor-pointer transition-colors ${purpose === 'expansion' ? 'border-primary bg-primary bg-opacity-5' : 'border-neutral-200 hover:border-primary'}`} onClick={() => setPurpose('expansion')} data-id="element-1339">
                <div className="w-10 h-10 rounded-full bg-neutral-200 flex items-center justify-center mb-3" data-id="element-1340">
                  <BuildingIcon className="w-5 h-5 text-neutral-500" data-id="element-1341" />
                </div>
                <h4 className="font-medium mb-1" data-id="element-1342">Business Expansion</h4>
                <p className="text-sm text-neutral-400" data-id="element-1343">
                  Open new locations or renovate
                </p>
              </div>
            </div>
            {purpose === 'equipment' && <div className="bg-primary bg-opacity-5 border border-primary border-opacity-20 rounded-lg p-4 text-sm" data-id="element-1344">
                <div className="flex items-start" data-id="element-1345">
                  <InfoIcon className="w-5 h-5 text-primary mr-2 mt-0.5 flex-shrink-0" data-id="element-1346" />
                  <div data-id="element-1347">
                    <p className="text-primary font-medium mb-1" data-id="element-1348">
                      Equipment Financing Details
                    </p>
                    <p className="text-neutral-500" data-id="element-1349">
                      Equipment financing is structured as an Ijarah (lease)
                      arrangement. You'll select equipment from approved
                      vendors, and investors will fund the purchase. You'll make
                      regular payments over the financing term, after which
                      you'll own the equipment.
                    </p>
                  </div>
                </div>
              </div>}
          </Card>
        </section>
        {/* Financing Configuration */}
        <section className="mb-8" data-id="element-1350">
          <Card data-id="element-1351">
            <h3 className="text-lg font-medium mb-4" data-id="element-1352">
              2. Configure Financing Terms
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-1353">
              {/* Amount Configuration */}
              <div data-id="element-1354">
                <label className="block text-sm font-medium mb-2" data-id="element-1355">
                  Financing Amount (RM)
                </label>
                <div className="mb-4" data-id="element-1356">
                  <input type="range" min="5000" max="50000" step="5000" value={amount} onChange={e => setAmount(parseInt(e.target.value))} className="w-full h-2 bg-neutral-200 rounded-lg appearance-none cursor-pointer" data-id="element-1357" />
                  <div className="flex justify-between text-xs text-neutral-400 mt-1" data-id="element-1358">
                    <span data-id="element-1359">RM 5,000</span>
                    <span data-id="element-1360">RM 50,000</span>
                  </div>
                </div>
                <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-1361">
                  <div className="text-sm mb-1" data-id="element-1362">Selected Amount</div>
                  <div className="text-xl font-bold text-primary" data-id="element-1363">
                    RM {amount.toLocaleString()}
                  </div>
                  <div className="text-xs text-neutral-400 mt-1" data-id="element-1364">
                    Recommended range for your business profile
                  </div>
                </div>
              </div>
              {/* Duration Selection */}
              <div data-id="element-1365">
                <label className="block text-sm font-medium mb-2" data-id="element-1366">
                  Financing Duration (Months)
                </label>
                <div className="grid grid-cols-3 gap-3 mb-4" data-id="element-1367">
                  {[6, 9, 12].map(months => <button key={months} type="button" className={`py-2 px-4 rounded-lg border ${duration === months ? 'bg-primary text-white border-primary' : 'border-neutral-200 text-neutral-500 hover:border-primary'}`} onClick={() => setDuration(months)} data-id="element-1368">
                      {months} months
                    </button>)}
                </div>
                <div className="bg-neutral-50 p-3 rounded-lg" data-id="element-1369">
                  <div className="text-sm mb-1" data-id="element-1370">
                    Monthly Payment (Estimated)
                  </div>
                  <div className="text-xl font-bold text-primary" data-id="element-1371">
                    RM{' '}
                    {Math.round(amount / duration * (1 + 0.18 * (duration / 12))).toLocaleString()}
                  </div>
                  <div className="text-xs text-neutral-400 mt-1" data-id="element-1372">
                    Based on 18% annual profit rate
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-secondary bg-opacity-5 border border-secondary border-opacity-20 rounded-lg p-4 text-sm" data-id="element-1373">
              <div className="flex items-center mb-2" data-id="element-1374">
                <CalendarIcon className="w-4 h-4 text-secondary mr-2" data-id="element-1375" />
                <span className="text-secondary font-medium" data-id="element-1376">
                  Repayment Schedule
                </span>
              </div>
              <p className="text-neutral-500 mb-3" data-id="element-1377">
                Daily payments will begin 1 day after funds are disbursed.
                You'll make {duration * 30} equal daily payments of
                approximately RM{' '}
                {Math.round(amount / (duration * 30) * (1 + 0.18 * (duration / 12))).toLocaleString()}
                .
              </p>
              <div className="flex justify-between text-xs border-t border-secondary border-opacity-20 pt-3" data-id="element-1378">
                <div data-id="element-1379">
                  <div className="text-neutral-400" data-id="element-1380">Total Repayment</div>
                  <div className="font-medium" data-id="element-1381">
                    RM{' '}
                    {Math.round(amount * (1 + 0.18 * (duration / 12))).toLocaleString()}
                  </div>
                </div>
                <div data-id="element-1382">
                  <div className="text-neutral-400" data-id="element-1383">Profit Rate</div>
                  <div className="font-medium" data-id="element-1384">18% p.a.</div>
                </div>
                <div data-id="element-1385">
                  <div className="text-neutral-400" data-id="element-1386">First Payment</div>
                  <div className="font-medium" data-id="element-1387">1 day after disbursement</div>
                </div>
              </div>
            </div>
          </Card>
        </section>
        {/* Equipment Details */}
        {purpose === 'equipment' && <section className="mb-8" data-id="element-1388">
            <Card data-id="element-1389">
              <h3 className="text-lg font-medium mb-4" data-id="element-1390">3. Equipment Details</h3>
              <div className="mb-6" data-id="element-1391">
                <label className="block text-sm font-medium mb-2" data-id="element-1392">
                  Vendor Selection
                </label>
                <select className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" value={selectedVendor} onChange={handleVendorChange} data-id="element-1393">
                  <option value="" data-id="element-1394">Select an approved vendor</option>
                  <option value="vendor1" data-id="element-1395">
                    Malaysian Coffee Equipment Co.
                  </option>
                  <option value="vendor2" data-id="element-1396">KL Restaurant Supplies</option>
                  <option value="vendor3" data-id="element-1397">Cafe Tech Solutions</option>
                  <option value="vendor4" data-id="element-1398">Global Food Equipment</option>
                  <option value="new_vendor" data-id="element-1399">+ Add New Vendor</option>
                </select>
                <div className="text-xs text-neutral-400 mt-1" data-id="element-1400">
                  All vendors are verified for Shariah compliance
                </div>
                {newVendorSubmitted && <div className="mt-3 bg-success bg-opacity-10 border border-success border-opacity-20 rounded-lg p-3 text-xs" data-id="element-1401">
                    <div className="flex items-center mb-1" data-id="element-1402">
                      <CheckIcon className="w-4 h-4 text-success mr-1 flex-shrink-0" data-id="element-1403" />
                      <span className="font-medium text-success" data-id="element-1404">
                        Vendor Submitted Successfully
                      </span>
                    </div>
                    <p className="text-neutral-600" data-id="element-1405">
                      Your vendor submission has been received and is pending
                      verification. You'll be notified once the vendor is
                      approved. The verification process typically takes 2-3
                      business days.
                    </p>
                  </div>}
                {!newVendorSubmitted && <div className="mt-3 bg-warning bg-opacity-10 border border-warning border-opacity-20 rounded-lg p-3 text-xs" data-id="element-1406">
                    <div className="flex items-center mb-1" data-id="element-1407">
                      <AlertCircleIcon className="w-4 h-4 text-warning mr-1 flex-shrink-0" data-id="element-1408" />
                      <span className="font-medium text-warning" data-id="element-1409">
                        Important Notice
                      </span>
                    </div>
                    <p className="text-neutral-600" data-id="element-1410">
                      If your preferred vendor is not listed, you can submit a
                      new vendor for verification. Please note that all new
                      vendors must be reviewed and verified for Shariah
                      compliance before your sukuk can be listed. This
                      verification process may take 2-3 business days.
                    </p>
                  </div>}
              </div>
              <div className="mb-6" data-id="element-1411">
                <label className="block text-sm font-medium mb-2" data-id="element-1412">
                  Equipment Description
                </label>
                <textarea className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" rows={3} placeholder="Describe the equipment you need to purchase..." defaultValue="Professional espresso machine and coffee grinder to expand our beverage menu offerings and improve service efficiency." data-id="element-1413"></textarea>
              </div>
              <div className="mb-6" data-id="element-1414">
                <label className="block text-sm font-medium mb-2" data-id="element-1415">
                  Upload Quotation
                </label>
                <div className="border-2 border-dashed border-neutral-200 rounded-lg p-6 text-center" data-id="element-1416">
                  <div className="flex flex-col items-center" data-id="element-1417">
                    <UploadIcon className="w-8 h-8 text-neutral-300 mb-2" data-id="element-1418" />
                    <p className="text-sm text-neutral-500 mb-2" data-id="element-1419">
                      Drag and drop your quotation file here, or click to browse
                    </p>
                    <p className="text-xs text-neutral-400" data-id="element-1420">
                      Accepted formats: PDF, JPG, PNG (Max 5MB)
                    </p>
                    <button type="button" className="mt-4 text-sm text-primary underline" data-id="element-1421">
                      Browse Files
                    </button>
                  </div>
                </div>
              </div>
            </Card>
          </section>}
        {/* Business Impact */}
        <section className="mb-8" data-id="element-1422">
          <Card data-id="element-1423">
            <h3 className="text-lg font-medium mb-4" data-id="element-1424">
              4. Business Growth Impact
            </h3>
            <div className="mb-6" data-id="element-1425">
              <label className="block text-sm font-medium mb-2" data-id="element-1426">
                How will this financing help your business grow?
              </label>
              <textarea className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" rows={3} placeholder="Describe how this investment will help your business..." defaultValue="The new espresso machine will allow us to serve customers more efficiently during peak hours and expand our menu with specialty coffee drinks. We expect to increase our daily coffee sales by 30% and attract new customers looking for premium coffee options." data-id="element-1427"></textarea>
            </div>
            <div className="mb-6" data-id="element-1428">
              <label className="block text-sm font-medium mb-2" data-id="element-1429">
                Community Benefits
              </label>
              <div className="space-y-3" data-id="element-1430">
                <div className="flex items-center" data-id="element-1431">
                  <input type="checkbox" id="benefit1" className="mr-2" defaultChecked data-id="element-1432" />
                  <label htmlFor="benefit1" className="text-sm" data-id="element-1433">
                    Offer special discounts to micro-sukuk investors
                  </label>
                </div>
                <div className="flex items-center" data-id="element-1434">
                  <input type="checkbox" id="benefit2" className="mr-2" defaultChecked data-id="element-1435" />
                  <label htmlFor="benefit2" className="text-sm" data-id="element-1436">
                    Create new job opportunities
                  </label>
                </div>
                <div className="flex items-center" data-id="element-1437">
                  <input type="checkbox" id="benefit3" className="mr-2" data-id="element-1438" />
                  <label htmlFor="benefit3" className="text-sm" data-id="element-1439">
                    Implement environmentally friendly practices
                  </label>
                </div>
                <div className="flex items-center" data-id="element-1440">
                  <input type="checkbox" id="benefit4" className="mr-2" data-id="element-1441" />
                  <label htmlFor="benefit4" className="text-sm" data-id="element-1442">
                    Participate in community events and initiatives
                  </label>
                </div>
              </div>
            </div>
            <div className="border border-neutral-200 rounded-lg p-4" data-id="element-1443">
              <h4 className="font-medium mb-3" data-id="element-1444">Custom Community Benefit</h4>
              <div className="mb-4" data-id="element-1445">
                <label className="block text-sm mb-1" data-id="element-1446">Benefit Title</label>
                <input type="text" className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" placeholder="e.g., 10% Off Any Coffee" defaultValue="10% Off Any Coffee" data-id="element-1447" />
              </div>
              <div data-id="element-1448">
                <label className="block text-sm mb-1" data-id="element-1449">
                  Benefit Description
                </label>
                <input type="text" className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" placeholder="Describe the benefit for investors" defaultValue="Investors can enjoy 10% off any coffee purchase by showing their investment certificate" data-id="element-1450" />
              </div>
            </div>
          </Card>
        </section>
        {/* Submit Section */}
        <section className="mb-8" data-id="element-1451">
          <Card data-id="element-1452">
            <div className="flex items-center mb-6" data-id="element-1453">
              <div className="w-10 h-10 rounded-full bg-accent bg-opacity-10 flex items-center justify-center mr-3" data-id="element-1454">
                <FileTextIcon className="w-5 h-5 text-accent" data-id="element-1455" />
              </div>
              <div className="flex-1" data-id="element-1456">
                <h3 className="font-medium" data-id="element-1457">Terms & Conditions</h3>
                <p className="text-sm text-neutral-400" data-id="element-1458">
                  Please review and accept the terms before submitting
                </p>
              </div>
            </div>
            <div className="space-y-3 mb-6" data-id="element-1459">
              <div className="flex items-center" data-id="element-1460">
                <input type="checkbox" id="terms1" className="mr-2" defaultChecked data-id="element-1461" />
                <label htmlFor="terms1" className="text-sm" data-id="element-1462">
                  I confirm that all information provided is accurate and
                  complete
                </label>
              </div>
              <div className="flex items-center" data-id="element-1463">
                <input type="checkbox" id="terms2" className="mr-2" defaultChecked data-id="element-1464" />
                <label htmlFor="terms2" className="text-sm" data-id="element-1465">
                  I agree to the Micro-Sukuk terms and Shariah compliance
                  requirements
                </label>
              </div>
              <div className="flex items-center" data-id="element-1466">
                <input type="checkbox" id="terms3" className="mr-2" defaultChecked data-id="element-1467" />
                <label htmlFor="terms3" className="text-sm" data-id="element-1468">
                  I understand that my application will be reviewed by a Digital
                  Advisor
                </label>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row justify-end gap-3" data-id="element-1469">
              <Button variant="outline" type="button" data-id="element-1470">
                Save as Draft
              </Button>
              <Button variant="primary" type="submit" data-id="element-1471">
                Submit for Review
              </Button>
            </div>
          </Card>
        </section>
      </form>
      {/* New Vendor Modal */}
      {showVendorModal && <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-1472">
          <div className="bg-white rounded-lg shadow-lg w-full max-w-lg max-h-[90vh] flex flex-col" data-id="element-1473">
            <div className="flex justify-between items-center p-4 border-b border-neutral-100 flex-shrink-0" data-id="element-1474">
              <h3 className="font-bold text-lg" data-id="element-1475">Submit New Vendor</h3>
              <button onClick={() => {
            setShowVendorModal(false);
            setSelectedVendor('');
          }} className="p-1 rounded-full hover:bg-neutral-100 transition-colors" data-id="element-1476">
                <XIcon className="w-5 h-5 text-neutral-400" data-id="element-1477" />
              </button>
            </div>
            <div className="overflow-y-auto p-4 flex-grow" data-id="element-1478">
              <form id="vendorForm" onSubmit={handleVendorSubmit} data-id="element-1479">
                <div className="space-y-4" data-id="element-1480">
                  <div data-id="element-1481">
                    <label className="block text-sm font-medium mb-2" data-id="element-1482">
                      Vendor Name<span className="text-error" data-id="element-1483">*</span>
                    </label>
                    <input type="text" className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" placeholder="Enter vendor name" required data-id="element-1484" />
                  </div>
                  <div data-id="element-1485">
                    <label className="block text-sm font-medium mb-2" data-id="element-1486">
                      Contact Person<span className="text-error" data-id="element-1487">*</span>
                    </label>
                    <input type="text" className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" placeholder="Enter contact person's name" required data-id="element-1488" />
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-1489">
                    <div data-id="element-1490">
                      <label className="block text-sm font-medium mb-2" data-id="element-1491">
                        Email Address<span className="text-error" data-id="element-1492">*</span>
                      </label>
                      <input type="email" className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" placeholder="Enter email address" required data-id="element-1493" />
                    </div>
                    <div data-id="element-1494">
                      <label className="block text-sm font-medium mb-2" data-id="element-1495">
                        Phone Number<span className="text-error" data-id="element-1496">*</span>
                      </label>
                      <input type="tel" className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" placeholder="Enter phone number" required data-id="element-1497" />
                    </div>
                  </div>
                  <div data-id="element-1498">
                    <label className="block text-sm font-medium mb-2" data-id="element-1499">
                      Business Registration Number
                      <span className="text-error" data-id="element-1500">*</span>
                    </label>
                    <input type="text" className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" placeholder="Enter business registration number" required data-id="element-1501" />
                  </div>
                  <div data-id="element-1502">
                    <label className="block text-sm font-medium mb-2" data-id="element-1503">
                      Business Address<span className="text-error" data-id="element-1504">*</span>
                    </label>
                    <textarea className="w-full border border-neutral-200 rounded-lg py-2 px-3 focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary" rows={2} placeholder="Enter business address" required data-id="element-1505"></textarea>
                  </div>
                  <div data-id="element-1506">
                    <label className="block text-sm font-medium mb-2" data-id="element-1507">
                      Upload Business Documents
                      <span className="text-error" data-id="element-1508">*</span>
                    </label>
                    <div className="border-2 border-dashed border-neutral-200 rounded-lg p-4 text-center hover:bg-neutral-50 transition-colors cursor-pointer" data-id="element-1509">
                      <div className="flex flex-col items-center" data-id="element-1510">
                        <UploadIcon className="w-6 h-6 text-neutral-300 mb-2" data-id="element-1511" />
                        <p className="text-xs text-neutral-500 mb-2" data-id="element-1512">
                          Upload business registration and relevant documents
                        </p>
                        <button type="button" className="mt-2 text-xs text-primary underline" data-id="element-1513">
                          Browse Files
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="bg-neutral-50 p-3 rounded-lg text-xs" data-id="element-1514">
                    <div className="flex items-center mb-1" data-id="element-1515">
                      <InfoIcon className="w-4 h-4 text-primary mr-1 flex-shrink-0" data-id="element-1516" />
                      <span className="font-medium" data-id="element-1517">Verification Process</span>
                    </div>
                    <p className="text-neutral-600" data-id="element-1518">
                      All vendors must be verified for Shariah compliance before
                      being approved. This process typically takes 2-3 business
                      days. You'll be notified once the verification is
                      complete.
                    </p>
                  </div>
                </div>
              </form>
            </div>
            <div className="p-4 border-t border-neutral-100 flex justify-end gap-3 flex-shrink-0 bg-white" data-id="element-1519">
              <Button type="button" variant="outline" onClick={() => {
            setShowVendorModal(false);
            setSelectedVendor('');
          }} data-id="element-1520">
                Cancel
              </Button>
              <Button type="submit" variant="primary" form="vendorForm" data-id="element-1521">
                Submit Vendor
              </Button>
            </div>
          </div>
        </div>}
    </div>;
};
export default SukukInitiation;